module.exports = __webpack_public_path__ + "3cfd0c71652cf314f93fae29085057d4.pdf";